export default class Accordion {
    constructor() {
        this.initAccordion();
    }

    initAccordion() {
        const triggers = document.querySelectorAll(".js-accordion-trigger");

        if (triggers.length) {
            triggers.forEach(trigger => {
                const parent = trigger.closest(".accordion__item");
                const content = parent.querySelector(".accordion__content");

                if (trigger.classList.contains("is-open")) {
                    content.style.maxHeight = content.scrollHeight + "px";
                }

                trigger.addEventListener("click", () => {
                    this.toggleAccordion(trigger);
                });
            });
        }
    }

    toggleAccordion(trigger) {
        const parent = trigger.closest(".accordion__item");
        const content = parent.querySelector(".accordion__content");

        const openItems = document.querySelectorAll(".accordion__item .is-open");
        openItems.forEach(item => {
            if (item !== trigger) {
                item.classList.remove("is-open");
                const siblingContent = item.closest(".accordion__item").querySelector(".accordion__content");
                siblingContent.style.maxHeight = null;
            }
        });

        if (trigger.classList.contains("is-open")) {
            trigger.classList.remove("is-open");
            content.style.maxHeight = null;
        } else {
            trigger.classList.add("is-open");
            content.style.maxHeight = content.scrollHeight + 25 + "px";
        }
    }
}

document.addEventListener("DOMContentLoaded", () => {
    new Accordion();
});
